export const getRelativeUrl = (path: string) => {
  const hasSlash = path.startsWith("/");
  return `${import.meta.env.VITE__LOCALE}${hasSlash ? path : `/${path}`}`;
};
